import { CloseOutlined, InfoCircleOutlined } from "@ant-design/icons";
import { useLazyQuery, useMutation, useQuery } from "@apollo/react-hooks";
import {
  Button,
  Checkbox,
  Col,
  DatePicker,
  Drawer,
  Form,
  Input,
  message,
  Row,
  Select,
  Tooltip,
  Upload
} from "antd";
import moment from "moment";
import { useEffect, useState } from "react";
import ReactPlayer from "react-player";
import { CustIcon } from "../../../Components/Svgs/Svgs";
import {
  ADD_CUSTOM_TASK,
  ASSIGN_TASK,
  DELETE_ASSIGNED_TUTORIAL,
  INSERT_CUSTOM_TASK_TUTORIAL,
  UPDATE_CUSTOM_TASK,
  UPDATE_CUSTOM_TASK_TUTORIAL
} from "../../../Graphql/mutations";
import {
  GET_CUSTOM_TASK,
  GET_TASK_RECURRING_TYPES,
  GET_TASK_TYPES,
  GET_TUTORIAL_TYPES,
  GET_USER_SHIFTS_DAY
} from "../../../Graphql/queries";
import { onFileUpload } from "../../Helper/MediaUploader";
import { Loader } from "../../Loader";
import "./AddCustomTaskDrawer.less";

const { REACT_APP_ASSETS_URL } = process.env;

const { TextArea } = Input;
const { Dragger } = Upload;

export const AddCustomTaskDrawer = ({
  visible,
  toggleDrawer,
  customTaskEditId,
  user_id,
  preAssignedTasks,
}) => {
  const formatDate = "YYYY-MM-DD";
  const defaultSelectedDate = moment().format(formatDate);
  const [form] = Form.useForm();
  const [uploadedFile, setUploadedFile] = useState(undefined);
  const [isUploading, setIsUploading] = useState(false);
  const [activateRecurringType, SetActivateRecurringType] = useState(false);
  const [activateTaskDate, setActivateTaskDate] = useState(true);
  const [taskType, SetTaskType] = useState();
  const [recurringType, SetRecurringType] = useState("daily");
  const [selectedTaskDate, SetSelectedTaskDate] = useState();
  const [taskStartDate, setTaskStartDate] = useState();
  const [taskEndDate, setTaskEndDate] = useState();
  const [selectedDayWeekly, setSelectedDayWeekly] = useState();
  const [selectedByDate, setSelectedByDate] = useState();

  const [
    GET_CUSTOM_TASK_DATA_QUERY,
    {
      data: customTaskData,
    },
  ] = useLazyQuery(GET_CUSTOM_TASK, {
    variables: { task_id: customTaskEditId },
    skip: !customTaskEditId,
  });

  const { data: userShiftsDays} = useQuery(
    GET_USER_SHIFTS_DAY,
    { variables: { user_id: user_id } }
  );

  const { data: taskTypeData, loading: taskTypeLoading } =
    useQuery(GET_TASK_TYPES);

  const { data: taskRecurringTypeData } =
    useQuery(GET_TASK_RECURRING_TYPES);

  const { data: tutorialTypeData, loading: tutorialTypeLoading } =
    useQuery(GET_TUTORIAL_TYPES);

  const [ADD_CUSTOM_TASK_MUTATION, { loading: isAddingTask }] =
    useMutation(ADD_CUSTOM_TASK);

  const [ASSIGN_TASK_MUTATION] =
    useMutation(ASSIGN_TASK);

  const [UPDATE_CUSTOM_TASK_MUTATION, { loading: isUpdatingTask }] =
    useMutation(UPDATE_CUSTOM_TASK);

  const [
    UPDATE_CUSTOM_TASK_TUTORIRAL_MUTATION,
    { loading: isUpdatingTaskTutorial },
  ] = useMutation(UPDATE_CUSTOM_TASK_TUTORIAL);

  const [
    DELETE_CUSTOM_TASK_TUTORIRAL_MUTATION,
    { loading: isDeletingTaskTutorial },
  ] = useMutation(DELETE_ASSIGNED_TUTORIAL);

  const [
    INSERT_CUSTOM_TASK_TUTORIRAL_MUTATION,
    { loading: isInsertingTaskTutorial },
  ] = useMutation(INSERT_CUSTOM_TASK_TUTORIAL);
  const weekDaysArray = userShiftsDays?.getUsersById?.user_shifts.flatMap(
    (shift) => shift.working_day
  );
  useEffect(() => {
    if (customTaskEditId) {
      GET_CUSTOM_TASK_DATA_QUERY({
        variables: { task_id: customTaskEditId },
      });
    }
  }, [customTaskEditId]);
  useEffect(() => {
    if (customTaskData) {
      setTaskDataToForm(customTaskData?.tasks_by_pk);
    }
  }, [customTaskData]);

  const setTaskDataToForm = async (customTaskData) => {
    if (typeof customTaskData?.task_json === "string") {
      return null;
    }
    await SetSelectedTaskDate(customTaskData?.task_json);
    let weeklyday = customTaskData?.task_json?.flatMap((shift) =>
      moment(shift).format("dddd")
    );
    if (customTaskData?.task_type === "during_day") {
      await SetRecurringType(customTaskData?.task_recurring_type);
      await SetActivateRecurringType(true);
      await form.setFieldsValue({
        recurring_type: customTaskData?.task_recurring_type,
      });
    }
    if (customTaskData?.task_recurring_type != "daily") {
      await setTaskStartDate(
        moment(customTaskData?.recurring_start_date).format(formatDate)
      );
      await setTaskEndDate(
        moment(customTaskData?.recurring_end_date).format(formatDate)
      );
      await form.setFieldsValue({
        startDate: moment(customTaskData?.recurring_start_date),
        endDate: moment(customTaskData?.recurring_end_date),
      });
    }
    // if (customTaskData?.task_recurring_type === "bi_weekly") {
    //   await setSelectedDayBiWeekly(weeklyday);
    //   await form.setFieldsValue({
    //     taskByBiWeelyDate: weeklyday,
    //   });
    // }
    if (customTaskData?.task_recurring_type === "weekly") {
      await setSelectedDayWeekly(weeklyday);
      await form.setFieldsValue({
        taskByWeelyDate: weeklyday,
      });
    }
    if (
      customTaskData?.task_recurring_type != "weekly" &&
      // customTaskData?.task_recurring_type != "bi_weekly" &&
      customTaskData?.task_recurring_type != "daily"
    ) {
      await setSelectedByDate(
        moment(customTaskData?.task_json[0], "YYYY-MM-DD")
      );
      await setActivateTaskDate(false);
      await form.setFieldsValue({
        taskByDate: moment(customTaskData?.task_json[0], "YYYY-MM-DD"),
      });
    }

    setUploadedFile({
      type: customTaskData?.task_tutorial_maps[0]?.tutorial.tutorial_type,
      fileUrl: customTaskData?.task_tutorial_maps[0]?.tutorial.tutorial_url,
    });
    
    form.setFieldsValue({
      task_type: customTaskData?.task_type,
      description: customTaskData?.description,
      tutorial_type:
        customTaskData?.task_tutorial_maps[0]?.tutorial.tutorial_type,
      tutorial_url:
        customTaskData?.task_tutorial_maps[0]?.tutorial.tutorial_url,
      requirement_atteched:
        customTaskData?.user_tasks_maps[0]?.required_attachment,
    });
  };

  const onAddUpdateCustomTask = async (values) => {
    if (!customTaskEditId) {
      let addComplete = await ADD_CUSTOM_TASK_MUTATION({
        variables: {
          task_type: values.task_type,
          description: values.description,
          task_recurring_type: recurringType,
          recurring_start_date: !!taskStartDate
            ? moment(taskStartDate).format(formatDate)
            : null,
          recurring_end_date: !!taskStartDate
            ? moment(taskEndDate).format(formatDate)
            : null,
          task_json: selectedTaskDate ?? [],
        },
      });

      if (!addComplete.errors) {
        let addTutorialSuccess;
        if (values.tutorial_url && values.tutorial_type) {
          addTutorialSuccess = await INSERT_CUSTOM_TASK_TUTORIRAL_MUTATION({
            variables: {
              task_id: addComplete.data.insert_tasks.task[0].task_id,
              tutorial_url: values.tutorial_url,
              tutorial_type: values.tutorial_type,
            },
          });
        } else {
          addTutorialSuccess = true;
        }
        if (addTutorialSuccess) {
          let isAssignedTask = await ASSIGN_TASK_MUTATION({
            variables: {
              tasks: [
                ...preAssignedTasks.user_tasks_map.flatMap(
                  ({ task, task_date, required_attachment }) => [
                    {
                      task_id: task.task_id,
                      task_type: task.task_type,
                      task_date: task_date,
                      required_attachment: required_attachment,
                    },
                  ]
                ),
                ...addComplete.data.insert_tasks.task.flatMap((t) => {
                  let insertArry = [];
                  selectedTaskDate.forEach((taskDate) => {
                    insertArry.push({
                      task_id: t.task_id,
                      task_type: t.task_type,
                      task_date: taskDate,
                      required_attachment: values.requirement_atteched,
                    });
                  });
                  return insertArry;
                }),
              ],
              user_id,
            },
          });
          if (!isAssignedTask.errors) {
            form.resetFields();
            message.success("Task Added Successfully");
            setUploadedFile(undefined);
            toggleDrawer();

            SetActivateRecurringType(false);
            setActivateTaskDate(true);
            SetTaskType();
            SetRecurringType("daily");
            SetSelectedTaskDate();
            setTaskStartDate();
            setTaskEndDate();
            setSelectedDayWeekly();
            setSelectedByDate();
          }
        }
      } else {
        message.error("Unable to add task");
      }
    } else {
      const updateTaskComplete = await UPDATE_CUSTOM_TASK_MUTATION({
        variables: {
          task_id: customTaskEditId,
          task_type: values.task_type,
          description: values.description,
          task_recurring_type: recurringType,
          recurring_start_date: !!taskStartDate
            ? moment(taskStartDate).format(formatDate)
            : null,
          recurring_end_date: !!taskEndDate
            ? moment(taskEndDate).format(formatDate)
            : null,
          task_json: selectedTaskDate ?? [],
        },
      });
      let updateTutorialComplete;
      if (values.tutorial_url && values.tutorial_type) {
        if (
          customTaskData.tasks_by_pk.task_tutorial_maps[0]?.tutorial.tutorial_id
        ) {
          updateTutorialComplete = await UPDATE_CUSTOM_TASK_TUTORIRAL_MUTATION({
            variables: {
              tutorial_id:
                customTaskData.tasks_by_pk.task_tutorial_maps[0]?.tutorial
                  .tutorial_id,
              tutorial_url: values.tutorial_url,
              tutorial_type: values.tutorial_type,
            },
          });
        } else {
          updateTutorialComplete = await INSERT_CUSTOM_TASK_TUTORIRAL_MUTATION({
            variables: {
              task_id: customTaskEditId,
              tutorial_url: values.tutorial_url,
              tutorial_type: values.tutorial_type,
            },
          });
        }
      } else {
        updateTutorialComplete = await DELETE_CUSTOM_TASK_TUTORIRAL_MUTATION({
          variables: {
            task_id: customTaskEditId,
          },
        });
      }
      // if (updateTaskComplete) {
      // }
      if (!updateTaskComplete?.errors && !updateTutorialComplete?.errors) {
        const updatedTask = updateTaskComplete.data.update_tasks_by_pk;
        let insertArry = [];
        selectedTaskDate.forEach((taskDate) => {
          insertArry.push({
            task_id: updatedTask.task_id,
            task_type: updatedTask.task_type,
            task_date: taskDate,
            required_attachment: values.requirement_atteched,
          });
        });
        let newPreAssignedTasks = preAssignedTasks.user_tasks_map
          .filter((el) => el.task.task_id != updatedTask.task_id)
          .flatMap(({ task, task_date, required_attachment }) => [
            {
              task_id: task.task_id,
              task_type: task.task_type,
              task_date: task_date,
              required_attachment: required_attachment,
            },
          ]);
        let isAssignedTask = await ASSIGN_TASK_MUTATION({
          variables: {
            tasks: [...newPreAssignedTasks, ...insertArry],
            user_id,
            required_attachment: values.requirement_atteched,
          },
        });
        if (!isAssignedTask.errors) {
          form.resetFields();

          message.success("Task Updated Successfully");
          setUploadedFile({});
          toggleDrawer();
        }
      } else {
        message.error("Unable to update task");
      }
    }
  };

  const beforeTutorialUpload = (file) => {
    let selectedType = form.getFieldValue("tutorial_type");
    switch (selectedType) {
      case "image":
        if (file.type.includes("image")) {
          setUploadedFile({ type: file.type.split("/")[0] });
          return true;
        } else {
          message.error("Please upload Image Only");
          return Upload.LIST_IGNORE;
        }

      case "video":
        if (file.type.includes("video")) {
          setUploadedFile({ type: file.type.split("/")[0] });
          return true;
        } else {
          message.error("Please upload Video Only");
          return Upload.LIST_IGNORE;
        }

      default:
        if (file.type.includes("video") || file.type.includes("image")) {
          setUploadedFile({ type: file.type.split("/")[0] });
          return true;
        } else {
          message.error("Please upload Image or Video Only");
          return Upload.LIST_IGNORE;
        }
    }
  };

  const onTutorialUploadSuccess = (fileUrl) => {
    setUploadedFile((prevState) => {
      return { ...prevState, fileUrl };
    });
    form.setFieldsValue({
      tutorial_url: fileUrl,
      tutorial_type: uploadedFile.type,
    });
  };

  const onRangeSelectDate = (dates) => {
    setTaskStartDate(dates);
    setActivateTaskDate(false);
    let duration = 7;
    if (recurringType === "weekly") {
      duration = 7;
      form.resetFields(["taskByWeelyDate"]);
    } else if (recurringType === "bi_weekly") {
      duration = 15;
    } else if (recurringType === "monthly") {
      duration = 30;
    } else if (recurringType === "quarterly") {
      duration = 90;
    } else if (recurringType === "semi_annually") {
      duration = 180;
    } else if (recurringType === "annually") {
      duration = 365;
    }

    if (!!dates) {
      const end_date = dates.clone().add(duration - 1, "days");
      form.setFieldsValue({
        endDate: end_date,
      });
      setTaskEndDate(end_date);
      setSelectedDayWeekly();
      // setSelectedDayBiWeekly();
      setSelectedByDate(null);
      form.resetFields(["taskByDate"]);
    }
  };

  const getTastType = (taskType) => {
    SetTaskType(taskType);
    if (taskType === "during_day") {
      SetActivateRecurringType(true);
      SetSelectedTaskDate([defaultSelectedDate]);
    } else {
      SetRecurringType("daily");
      setSelectedDayWeekly();
      // setSelectedDayBiWeekly();
      setSelectedByDate(null);
      form.setFieldsValue({ recurring_type: "daily" });
      SetActivateRecurringType(false);
      SetSelectedTaskDate([defaultSelectedDate]);
      setTaskStartDate(null);
      setTaskEndDate(null);
    }
  };

  const onChangeRecurringType = (selctedRecurringType) => {
    SetRecurringType(selctedRecurringType);
    setTaskStartDate(null);
    setTaskEndDate(null);
    form.resetFields([
      "endDate",
      "startDate",
      "taskByDate",
      "taskByWeelyDate",
      "taskByBiWeelyDate",
    ]);
    setSelectedDayWeekly();
    // setSelectedDayBiWeekly();
    setActivateTaskDate(true);
    // activateRecurringType
    SetSelectedTaskDate([defaultSelectedDate]);
  };
  const onSelectWeeklyDay = (selectedDay) => {
    setSelectedDayWeekly(selectedDay);
    const range = Array(7)
      .fill()
      .map((a, i) => taskStartDate.clone().add(i, "days"));
    const taskDate = [
      range
        .find(
          (dateRange) =>
            dateRange.format("dddd").toLowerCase() === selectedDay.toLowerCase()
        )
        .format(formatDate),
    ];
    SetSelectedTaskDate(taskDate);
  };

  // const onSelectBiWeeklyDay = (selectedDay) => {
  //   if (taskStartDate) {
  //     const range = Array(7)
  //       .fill()
  //       .map((a, i) => taskStartDate.clone().add(i, "days"));
  //     SetSelectedTaskDate(
  //       range
  //         .filter((dateRange) => selectedDay.includes(dateRange.format("dddd")))
  //         .flatMap((d) => [d.format(formatDate)])
  //     );
  //   }
  //   setSelectedDayBiWeekly(selectedDay);

  // };
  const onDefaultDateSet = (dates) => {
    setSelectedByDate(dates);
    SetSelectedTaskDate([dates?.format(formatDate)]);
  };

  return (
    <Drawer
      placement="right"
      closable={false}
      width={720}
      visible={visible}
      maskStyle={{ backgroundColor: "#000000CC" }}
    >
      <Row className="headerRow" justify="space-between" align="middle">
        <Col>
          <h5 className="mb-0">
            {!!customTaskEditId ? "Edit" : "Add"} custom task
          </h5>
        </Col>
        <Col>
          <Button
            type="text"
            icon={<CloseOutlined />}
            onClick={() => {
              form.resetFields();
              setUploadedFile(undefined);
              toggleDrawer();
            }}
          />
        </Col>
      </Row>
      {taskTypeLoading || tutorialTypeLoading ? (
        <Loader />
      ) : (
        <Form form={form} onFinish={onAddUpdateCustomTask}>
          <Row className="mt-4 mx-3" gutter={16}>
            <Col xs={24} md={12}>
              <Tooltip
                trigger={["focus"]}
                title="Select task type"
                placement="topLeft"
                overlayClassName="numeric-input"
              >
                <Form.Item
                  name="task_type"
                  hasFeedback
                  rules={[
                    { required: true, message: "Please select task type" },
                  ]}
                >
                  <Select placeholder="Select task type" onChange={getTastType}>
                    {taskTypeData?.task_types?.map((singleTaskType, index) => (
                      <Select.Option key={index} value={singleTaskType.type_id}>
                        {singleTaskType.type_name}
                      </Select.Option>
                    ))}
                  </Select>
                </Form.Item>
              </Tooltip>
            </Col>
            {activateRecurringType && (
              <Col xs={24} md={12}>
                <Tooltip
                  trigger={["focus"]}
                  title="Select frequency"
                  placement="topLeft"
                  overlayClassName="numeric-input"
                >
                  <Form.Item
                    name="recurring_type"
                    hasFeedback
                    rules={[
                      { required: true, message: "Please select frequency" },
                    ]}
                    initialValue={"daily"}
                  >
                    <Select
                      placeholder="Select task type"
                      value={recurringType}
                      className="onChangeRecurringType"
                      onChange={onChangeRecurringType}
                    >
                      {taskRecurringTypeData?.task_recurring_types.map(
                        (singleRecurringType, index) => (
                          <Select.Option
                            key={index}
                            value={singleRecurringType.recurring_type}
                          >
                            {singleRecurringType.recurring_type_name}
                          </Select.Option>
                        )
                      )}
                    </Select>
                  </Form.Item>
                </Tooltip>
              </Col>
            )}
            {recurringType != "daily" && activateRecurringType && (
              <>
                <Col xs={24} md={12}>
                  <Tooltip
                    trigger={["focus"]}
                    title="Choose start date"
                    placement="topLeft"
                    // overlayClassName="numeric-input"
                  >
                    <Form.Item
                      name="startDate"
                      hasFeedback
                      rules={[
                        {
                          required: true,
                          message: "Please choose a start date",
                        },
                      ]}
                    >
                      <DatePicker
                        format="MM-DD-YYYY"
                        value={taskStartDate ?? null}
                        disabledDate={(date) => moment(date).isBefore()}
                        className="w-100"
                        onChange={onRangeSelectDate}
                      />
                    </Form.Item>
                  </Tooltip>
                </Col>
                <Col xs={24} md={12}>
                  <Tooltip
                    trigger={["focus"]}
                    title="Select start date"
                    placement="topLeft"
                    // overlayClassName="numeric-input"
                  >
                    <Form.Item
                      name="endDate"
                      hasFeedback
                      rules={[
                        { required: true, message: "Please select start date" },
                      ]}
                    >
                      <DatePicker
                        format="MM-DD-YYYY"
                        disabled
                        value={taskEndDate}
                        placeholder=""
                        className="w-100"
                      />
                    </Form.Item>
                  </Tooltip>
                </Col>
                <Col xs={24} md={12}>
                  {recurringType === "weekly" ? (
                    <Tooltip
                      trigger={["hover"]}
                      title="Select day of the task to be assigned"
                      placement="topLeft"
                      overlayClassName="numeric-input"
                    >
                      <Form.Item
                        name="taskByWeelyDate"
                        hasFeedback
                        rules={[
                          {
                            required: true,
                            message:
                              "Please select day of the task to be assigned",
                          },
                        ]}
                      >
                        <Select
                          disabled={!!taskStartDate ? false : true}
                          value={selectedDayWeekly}
                          className="w-100"
                          placeholder="Select day"
                          onChange={onSelectWeeklyDay}
                        >
                          {userShiftsDays?.getUsersById?.user_shifts?.map(
                            (shift, index) => (
                              <Select.Option
                                key={index}
                                value={shift.working_day}
                              >{`${shift.working_day}`}</Select.Option>
                            )
                          )}
                        </Select>
                      </Form.Item>
                    </Tooltip>
                  ) : (
                    // : recurringType === "bi_weekly" ? (
                    //   <Tooltip
                    //     trigger={["hover"]}
                    //     title="Select task "
                    //     placement="topLeft"
                    //     overlayClassName="numeric-input"
                    //   >
                    //     <Form.Item
                    //       name="taskByBiWeelyDate"
                    //       hasFeedback
                    //       rules={[
                    //         {
                    //           required: true,
                    //           message: "Please enter a two task day",
                    //         },
                    //       ]}
                    //     >
                    //       <Select
                    //         placeholder="Select day"
                    //         disabled={!!taskStartDate ? false : true}
                    //         // mode="multiple"
                    //         className="w-100"
                    //         value={selectedDayBiWeekly}
                    //         onChange={onSelectBiWeeklyDay}
                    //       >
                    //         {userShiftsDays?.getUsersById?.user_shifts?.map(
                    //           (shift, index) => (
                    //             <Select.Option
                    //               disabled={
                    //                 selectedDayBiWeekly?.length >= 2
                    //                   ? selectedDayBiWeekly.indexOf(
                    //                       shift.working_day
                    //                     ) >= 0
                    //                     ? false
                    //                     : true
                    //                   : false
                    //               }
                    //               key={index}
                    //               value={shift.working_day}
                    //             >{`${shift.working_day}`}</Select.Option>
                    //           )
                    //         )}
                    //       </Select>
                    //     </Form.Item>
                    //   </Tooltip>
                    // )
                    <Tooltip
                      trigger={["hover"]}
                      title="Select date of the task to be assigned"
                      placement="topLeft"
                      overlayClassName="numeric-input"
                    >
                      <Form.Item
                        name="taskByDate"
                        hasFeedback
                        rules={[
                          {
                            required: true,
                            message:
                              "Please select date of the task to be assigned",
                          },
                        ]}
                      >
                        <DatePicker
                          format="MM-DD-YYYY"
                          disabledDate={(date) =>
                            moment(date).isBefore(taskStartDate) ||
                            moment(date).add(-1, "day").isAfter(taskEndDate) ||
                            !weekDaysArray.includes(date.format("dddd"))
                          }
                          value={selectedByDate}
                          placeholder=""
                          className="w-100"
                          onChange={onDefaultDateSet}
                          disabled={activateTaskDate}
                        />
                      </Form.Item>
                    </Tooltip>
                  )}
                </Col>
              </>
            )}
            <Col xs={24} md={12}>
              {/* {selectedTaskDate}, {taskStartDate},{taskEndDate} */}
            </Col>
            <Col xs={24} md={24}>
              <Tooltip
                trigger={["focus"]}
                title="Description"
                placement="topLeft"
                overlayClassName="numeric-input"
              >
                <Form.Item
                  name="description"
                  hasFeedback
                  rules={[
                    {
                      required: true,
                      message: "Please enter a task description",
                      whitespace: true,
                    },
                  ]}
                >
                  <TextArea rows={3} placeholder="Description" />
                </Form.Item>
              </Tooltip>
            </Col>
            <Col xs={24} md={12}>
              <Tooltip
                trigger={["focus"]}
                title="Select tutorial type"
                placement="topLeft"
                overlayClassName="numeric-input"
              >
                <Form.Item name="tutorial_type">
                  <Select
                    disabled={!!uploadedFile?.fileUrl}
                    placeholder="Select tutorial type"
                  >
                    {tutorialTypeData?.tutorial_types?.map(
                      (singleTutorialType, index) => (
                        <Select.Option
                          key={index}
                          value={singleTutorialType.type_id}
                        >
                          {singleTutorialType.type_name}
                        </Select.Option>
                      )
                    )}
                  </Select>
                </Form.Item>
              </Tooltip>
            </Col>
            <Col xs={24} md={12}>
              <Form.Item name="requirement_atteched" valuePropName="checked">
                <Checkbox>
                  Picture Attestation Required?{" "}
                  <Tooltip
                    placement="topRight"
                    title="Employee needs to upload the proof of attestation when the task is completed"
                  >
                    <InfoCircleOutlined />
                  </Tooltip>{" "}
                </Checkbox>
              </Form.Item>
            </Col>
            <Col xs={24} md={24}>
              <Form.Item name="tutorial_url">
                {!uploadedFile?.fileUrl ? (
                  <Dragger
                    showUploadList={false}
                    customRequest={(e) => {
                      setIsUploading(true);
                      onFileUpload(
                        e,
                        "tutorials",
                        onTutorialUploadSuccess,
                        setIsUploading
                      );
                    }}
                    beforeUpload={beforeTutorialUpload}
                  >
                    <p className="ant-upload-drag-icon">
                      <CustIcon type="upload" />
                    </p>
                    <p className="ant-upload-text">
                      Upload only image and video file
                    </p>
                  </Dragger>
                ) : (
                  <div className="uploadedFile_blk">
                    {uploadedFile.type === "image" ? (
                      <div className="uploadedFile">
                        <img
                          className=""
                          src={REACT_APP_ASSETS_URL + uploadedFile.fileUrl}
                        ></img>
                        <span
                          onClick={() => {
                            setUploadedFile({});
                            form.setFieldsValue({
                              tutorial_url: "",
                              tutorial_type: "",
                            });
                          }}
                        >
                          <CustIcon type="close" />
                        </span>
                      </div>
                    ) : (
                      <div className="uploadedFile">
                        <ReactPlayer
                          controls
                          id="tutorialVideo"
                          url={REACT_APP_ASSETS_URL + uploadedFile.fileUrl}
                          width={"100%"}
                          height={"100%"}
                        ></ReactPlayer>
                        <span
                          onClick={() => {
                            setUploadedFile({});
                            form.setFieldsValue({
                              tutorial_url: "",
                              tutorial_type: "",
                            });
                          }}
                        >
                          <CustIcon type="close" />
                        </span>
                      </div>
                    )}
                  </div>
                )}
              </Form.Item>
            </Col>
            <Col xs={24} md={24}>
              <div className="mt-3 mb-4 text-center">
                <Button
                  type="primary"
                  shape="round"
                  size="large"
                  className="h-auto"
                  htmlType="submit"
                  loading={
                    isAddingTask ||
                    isUpdatingTask ||
                    isUpdatingTaskTutorial ||
                    isInsertingTaskTutorial ||
                    isDeletingTaskTutorial ||
                    isUploading
                  }
                >
                  {isUploading
                    ? "Uploading"
                    : !!customTaskEditId
                    ? isUpdatingTask ||
                      isUpdatingTaskTutorial ||
                      isDeletingTaskTutorial ||
                      isInsertingTaskTutorial
                      ? "Updating"
                      : "Update"
                    : isAddingTask
                    ? "Adding"
                    : "Add"}
                </Button>
              </div>
            </Col>
          </Row>
        </Form>
      )}
    </Drawer>
  );
};
